<template>
  <div class="info h-100 bg-black-05 overflow-y-scroll textColor">
    <div v-show="loading" class="flex justify-center items-center h5">
      <pulse-loader :loading="loading" :color="color" :size="size"></pulse-loader>
    </div>
    <p v-show="!hasInfo" class="pa2 center tc">{{ $t("artists.hasNotInfo")}}</p>
    <p v-show="hasInfo" class="ma0 pa2 f4 lh-copy">
      <i class="db mv2 tc">{{ artist.phrase }}</i>
    </p>
    <p v-show="hasInfo" class="ma0 pa2">{{ artist.text }}</p>
  </div>
</template>

<script>
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
  import { mapGetters } from 'vuex'

  export default {
    name: 'artist-info',
    components: {
      PulseLoader
    },
    data () {
      return {
        color: '#808080',
        size: '10px'
      }
    },
    computed: {
      ...mapGetters('artist', [
        'artist'
      ]),
      hasInfo () {
        return this.artist.phrase !== ''
      },
      loading () {
        return this.$loading.isLoading('artist getArtist')
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';
  .info {
    bottom: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/components/artistProfile/ArtistInfo.vue